import React, { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import OutcomeCol from 'common/EventRow/OutcomeComponent/OutcomeCol';
import eventShape from 'common/PropTypes/eventShape';
import marketTypeShape from 'common/PropTypes/marketTypeShape';
import MarketTypeHeader from 'components/Pages/Details/DetailsMarketType/MarketTypeHeader';

const MarketTypeDefaultView = ({
  data,
  event,
  expandedMarketTypes,
  isFavorite,
  marketType,
  setExpandedMarketTypes,
  suspended,
}) => {
  const { betGroups = [], id: marketTypeId, name, show: expandedByDefault } = marketType;

  const isExpanded = useMemo(
    () => expandedMarketTypes[marketTypeId] ?? expandedByDefault,
    [expandedByDefault, expandedMarketTypes, marketTypeId],
  );

  return (
    <div className="details-market-container">
      <MarketTypeHeader
        betGroups={betGroups}
        expandedMarketTypes={expandedMarketTypes}
        isExpanded={isExpanded}
        isFavorite={isFavorite}
        marketTypeId={marketTypeId}
        name={name}
        setExpandedMarketTypes={setExpandedMarketTypes}
      />

      <If condition={isExpanded}>
        <div className="MarketTypeDefaultView">
          <If condition={data?.header?.length}>
            <div className="MarketTypeDefaultView__competitors-block ">
              {data.header.map((v, index) => {
                if (!v) {
                  return <div className="MarketTypeDefaultView__cell" key={index} />;
                }
                return (
                  <div className="MarketTypeDefaultView__cell" key={index}>
                    {v}
                  </div>
                );
              })}
            </div>
          </If>
          {data.rows.map((row, rowIndex) => (
            <div className="MarketTypeDefaultView__row" key={`${marketTypeId}-${rowIndex}`}>
              {row.map((outcome, index) => {
                const outcomeClasses = cx([
                  !outcome?.name && 'center',
                  outcome.isFake && outcome.className,
                ]);

                return (
                  <div
                    className="MarketTypeDefaultView__cell odds-grid"
                    key={`${marketTypeId}-${rowIndex}-${index}`}
                  >
                    <OutcomeCol
                      className={cx('primary row', outcomeClasses)}
                      customName={outcome?.name}
                      dataTestId="event-details-outcome"
                      dataTestItemId={outcome.id}
                      event={event}
                      isFake={outcome.isFake}
                      market={{ id: outcome.marketId }}
                      marketType={marketType}
                      outcome={outcome}
                      suspended={suspended}
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </If>
    </div>
  );
};

MarketTypeDefaultView.propTypes = {
  data: PropTypes.object.isRequired,
  event: eventShape.isRequired,
  expandedMarketTypes: PropTypes.objectOf(PropTypes.bool),
  isFavorite: PropTypes.bool,
  marketType: marketTypeShape.isRequired,
  setExpandedMarketTypes: PropTypes.func,
};

export default MarketTypeDefaultView;
